import React from "react";
import ReactDOM from "react-dom/client"; // Correct import for ReactDOM
// import { BrowserRouter } from "react-router-dom"; // Correct import for BrowserRouter
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <App />
);
